import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import * as _ from "lodash"
import {ColumnNodeProvider} from "../PA.UIM.Core/SearchTreeUtils";
import { DateUtils } from "../PA.Core/Basic/Dates";

const vUI_Simulation_Search_Fields: {[id: string]: ISearchProviderField}  = {
    WB_SIMULATION_ID:          {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'WB Simulation Id',     columnResourceName: 'colId',             alignment: HorizAlignment.Left},  domainOptions: {} },
    WB_MDSET_ID:               {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'WB MDSet Id',          columnResourceName: 'colId',             alignment: HorizAlignment.Left},  domainOptions: {} },
    WB_SALESORG_ID:            {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'WB SalesOrg Id',       columnResourceName: 'colId',             alignment: HorizAlignment.Left},  domainOptions: {} },
    WB_TREE_FOLDER_ID:         {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'WB Folder Id',         columnResourceName: 'colId',             alignment: HorizAlignment.Left},  domainOptions: {} },
    WB_TREE_FOLDER_ID_SHARED:  {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'WB Folder Id',         columnResourceName: 'colId',             alignment: HorizAlignment.Left},  domainOptions: {} },
    WB_AUTHUSR_ID_CREATEDBY:   {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'WB User Id',           columnResourceName: 'colId',             alignment: HorizAlignment.Left},  domainOptions: {} },
    WB_PUBLISHED_MODEL_ID:     {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'WB Published Model Id',   columnResourceName: 'colId',             alignment: HorizAlignment.Left},  domainOptions: {} },
    WB_CUST_ID:                {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'WB Cust Id',           columnResourceName: 'colId',             alignment: HorizAlignment.Left},  domainOptions: {} },
    WB_CBO_ID:                 {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'WB CBO Id',            columnResourceName: 'colId',             alignment: HorizAlignment.Left},  domainOptions: {} },
    CBO_ID:                    {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Optimizer Id',         columnResourceName: 'colOptimizerId',    alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    CBO_NAME:                  {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Optimization Session', columnResourceName: 'colOptimiizerName', alignment: HorizAlignment.Left, columnWidthCharacters: 20, linkWbIdFieldName: 'WB_CBO_ID',  linkAppExecId: 'CBO'},  domainOptions: {maxLength: 150}},
    SIMULATION_ID:             {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Promotion Id',         columnResourceName: 'colSimulationId',   alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    SIMULATION_NAME:           {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Promotion Name',       columnResourceName: 'colSimulationName', alignment: HorizAlignment.Left},  domainOptions: {maxLength: 150}},
    CUSTOMER_NAME:             {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Customer Name',        columnResourceName: 'colCustomerName',   alignment: HorizAlignment.Left, columnWidthCharacters: 20},  domainOptions: {maxLength: 150}},
    TEMPLATE_NAME:             {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Template',             columnResourceName: 'colTemplateName',   alignment: HorizAlignment.Left, columnWidthCharacters: 20},  domainOptions: {maxLength: 150}},
    START_DT:                  {type: SearchProviderFieldType.sapdate, renderOptions: { columnName: 'Start Date',           columnResourceName: 'colStart',          dateFormat:'MM/dd/yyyy' , alignment: HorizAlignment.Right, columnWidthCharacters: 10}, domainOptions: {}},
    END_DT:                    {type: SearchProviderFieldType.sapdate, renderOptions: { columnName: 'End Date',             columnResourceName: 'colEnd',            dateFormat:'MM/dd/yyyy' , alignment: HorizAlignment.Right, columnWidthCharacters: 10}, domainOptions: {}},
    DURATION:                  {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'Days',      columnResourceName: 'colDuration',       alignment: HorizAlignment.Right, numberFormat: "#,##0"},  domainOptions: {} },
    LAST_CALC_DTTS:            {type: SearchProviderFieldType.sapdate, renderOptions: { columnName: 'Calculated Date',      columnResourceName: 'colCalc' ,          dateFormat:'MM/dd/yyyy', alignment: HorizAlignment.Right, columnWidthCharacters: 10}, domainOptions: {}},
    CREATED_DTTS:              {type: SearchProviderFieldType.sapdate, renderOptions: { columnName: 'Created Date',         columnResourceName: 'colCreatedDt' ,     dateFormat:'MM/dd/yyyy', alignment: HorizAlignment.Right, columnWidthCharacters: 10}, domainOptions: {}},
    MODIFIED_DTTS:             {type: SearchProviderFieldType.sapdate, renderOptions: { columnName: 'Last Modified Date',   columnResourceName: 'colModify' ,        dateFormat:'MM/dd/yyyy', alignment: HorizAlignment.Right, columnWidthCharacters: 10}, domainOptions: {}},
    AUTHUSR_EMAIL:             {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Created By',           columnResourceName: 'colCreatedBy',      alignment: HorizAlignment.Left, columnWidthCharacters: 25},  domainOptions: {} },
    WB_PRDH_ID:                {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'WB PrdH Id',           columnResourceName: 'colWBPrdHId',       alignment: HorizAlignment.Left},  domainOptions: {} },
    METRIC_PRD_COUNT:          {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'Product Count ',       columnResourceName: 'colProductCount', alignment: HorizAlignment.Right, numberFormat: "#,000."},  domainOptions: {}},
    ROI:                       {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'ROI',                  columnResourceName: 'colROI',          alignment: HorizAlignment.Right},  domainOptions: {}},
    SPEND_TOTAL:               {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Total Spend',          columnResourceName: 'colROI',          alignment: HorizAlignment.Right, columnWidthCharacters: 15},  domainOptions: {}},
    SPEND_FIXED:               {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Fixed Spend',          columnResourceName: 'colROI',          alignment: HorizAlignment.Right, columnWidthCharacters: 15},  domainOptions: {}},
    SPEND_VARIABLE:            {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Variable Spend',       columnResourceName: 'colROI',          alignment: HorizAlignment.Right, columnWidthCharacters: 15},  domainOptions: {}},
    SHELF_DISCOUNT:            {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Discount %',           columnResourceName: 'colROI',          alignment: HorizAlignment.Right},  domainOptions: {}},
    SHIPMENT_GROSS_LIST_SALES: {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Gross List Sales',     columnResourceName: 'colROI',          alignment: HorizAlignment.Right, columnWidthCharacters: 15},  domainOptions: {}},
    SHIPMENT_NET_LIST_SALES:   {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Customer List Sales',  columnResourceName: 'colROI',          alignment: HorizAlignment.Right, columnWidthCharacters: 15},  domainOptions: {}},
    RETAILER_MARGIN:           {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Retailer Margin',      columnResourceName: 'colROI',          alignment: HorizAlignment.Right, columnWidthCharacters: 15},  domainOptions: {}},
    RETAILER_MARGIN_PCT:       {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Retailer Margin %',    columnResourceName: 'colROI',          alignment: HorizAlignment.Right},  domainOptions: {}},
    LIFT_PCT:                  {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Lift %',               columnResourceName: 'colROI',          alignment: HorizAlignment.Right},  domainOptions: {}},
};

const SimulationInputSearchProviderBasic: ISearchProvider = {

    keyFields: {id:    'WB_SIMULATION_ID',
                id_ui: 'SIMULATION_ID',
                name:  'SIMULATION_NAME'
    },

    searchProviderFields: vUI_Simulation_Search_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error)=>{
            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_Simulation_Metric_Search',
                this.searchProviderFields,
                []);

            PASearch.findByRequest(findRequest)
                .then((res: any[])=> {
                    _.forEach(res, (a) => {
                        const startDt = DateUtils.convertFromSAPBW(a.START_DT)
                        const endDt = DateUtils.convertFromSAPBW(a.END_DT)
                        const dur = DateUtils.durationInDays({StartDt: startDt, EndDt: endDt})
                        a.DURATION = dur
                    })
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                });
        })
    }
};

const SimulationSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: {ui5SourceId: "SimulationSearchProfileByName"},

    profileFilter: [
        {profileFilterName: 'Id', searchProviderFieldId: 'SIMULATION_ID', renderOptions: {}},
        {profileFilterName: 'Name', searchProviderFieldId: 'SIMULATION_NAME', renderOptions: {}},
        {profileFilterName: 'Customer', searchProviderFieldId: 'CUSTOMER_NAME', renderOptions: {}, bQuickSearch: true}
    ], //ISearchFields
    profileDisplayFields: [
        'SIMULATION_ID', 'SIMULATION_NAME', 'CUSTOMER_NAME', 'START_DT', 'DURATION', 'ROI', 'SPEND_TOTAL', 'SHIPMENT_GROSS_LIST_SALES', 'RETAILER_MARGIN_PCT', 'LIFT_PCT', 'SHELF_DISCOUNT', 'LAST_CALC_DTTS', 'CREATED_DTTS', 'AUTHUSR_EMAIL', 'TEMPLATE_NAME', 'CBO_NAME'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: SimulationInputSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};



const SimulationComparisonSearchProvider: ISearchProvider = {

    keyFields: {id: 'WB_SIMULATION_ID',
                id_ui: 'SIMULATION_ID',
                name:  'SIMULATION_NAME'

    },

    searchProviderFields: vUI_Simulation_Search_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error)=>{
            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_Simulation_Metric_Search',
                this.searchProviderFields,
                []);

            PASearch.findByRequest(findRequest)
                .then((res: any[])=> {
                    // Calculate Duration
                    _.forEach(res, (a) => {
                        const startDt = DateUtils.convertFromSAPBW(a.START_DT)
                        const endDt = DateUtils.convertFromSAPBW(a.END_DT)
                        const dur = DateUtils.durationInDays({StartDt: startDt, EndDt: endDt})
                        a.DURATION = dur
                    })
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                });
        })
    }
};

const SimulationComparisonSearchProfile: ISearchProfile = {
    profileId: "SimulationComparisonSearchProfile",
    profileName: "Simulation Comparison",
    renderOptions: {ui5SourceId: "SimulationComparisonSearchProfile"},

    profileFilter: [
        {profileFilterName: 'Id', searchProviderFieldId: 'SIMULATION_ID', renderOptions: {}},
        {profileFilterName: 'Name', searchProviderFieldId: 'SIMULATION_NAME', renderOptions: {}}
    ], //ISearchFields
    profileDisplayFields: [
        'SIMULATION_ID', 'SIMULATION_NAME','START_DT','END_DT'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: SimulationComparisonSearchProvider,

    profileTreeIdDefault: "ByDirectoryPath",
    profileTrees: [
        /*
        {treeId: "ByDirectoryPath",
            treeName: "By Hierarchy",
            nodeProviders: [new ColumnNodeProvider(['TREE_PATH'], {defaultValues: "Tree Path not set", levelDelimiter: "/", ruggedTree: true})],
            renderOptions: {ui5: {leafIcon: "sap-icon://Chart-Tree-Map"}}} */
    ],

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};

const SimulationSearch: ISearch = {
    searchName: "Find Simulation",
    renderOptions: {ui5ResourceId: "SimulationSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [SimulationSearchProfileByName]
};

const SimulationComparisonSearch: ISearch = {
    searchName: "Find Promotions",
    renderOptions: {ui5ResourceId: "SimulationSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [SimulationComparisonSearchProfile]
};
PAEnvironment.registerBusinessObjectSearch("SimulationBO", "Simulation", SimulationSearch, "Simulation Search")

export {SimulationSearch, SimulationComparisonSearch}

